import styled from "styled-components";

export const ActivitySeatDetailContainerStyled = styled.div`
  padding: 20px 20px 40px 20px;
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  .seat_detail_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
  }
  .activity_wrap {
    margin-bottom: 18px;
  }
  .activity_title {
    margin-bottom: 6px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
  }
  .activity_desc {
    margin-bottom: 20px;
    color: ${({ theme }) => theme.COLORS.BLACK_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  }
  .activity_img2 {
    margin-bottom: 20px;
  }
  /* ปุ่มหลักตาม design: กว้าง 294 สูง 48 กึ่งกลาง ปุ่มกลับขนาดเดียวกันห่าง 16 */
  .booking_btn,
  .back_btn {
    max-width: 294px;
    margin: 0 auto;
  }
  .booking_btn {
    margin-bottom: 16px;
  }
  .notice_text {
    margin-top: 8px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.RED_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  }
  .section_title {
    margin-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
  }
  .my_bookings {
    margin: 8px 0 16px;
  }
  /* มือถือไม่มี breadcrumb เหมือนหน้ากิจกรรมเดิม (ขอบซ้ายขวา 16px ตาม design) */
  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 16px 40px 16px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
